module.exports = __webpack_public_path__ + "media/images/shared/delivery/bsd-46fcaf4bc95f506e09aea49f188b9d22.png";